import { ReactElement, ReactNode } from 'react'
import { TableHeaderProps } from './interface'
import TableHeader from './head'
import TableData from './body'
import { StyleTableWrapper, StyleTable } from './style'
import Pagination from './pagination'
import Filter from './filter'
import TableLoader from './loader/TableLoader'

export interface FilterProps {
  hasFilter?: boolean
  hasSearch?: boolean
  onSearch?: (event: any) => void
  rightComponent?: ReactElement
  placeholder?: string
  filterComponent?: ReactElement
}
interface PaginationProps {
  activePage: number
  totalPages: number
  perPage?: number
  handleOnClick: (pageNumber: number) => void
}
interface TableProps {
  data?: any[]
  columns: TableHeaderProps[]
  footer?: ReactNode
  onClickRow?: (item: any, e: any) => void
  loading?: boolean
  filter?: FilterProps
  paginationProps?: PaginationProps
  tableCS?: any
  hasBorderBottom?: boolean
  loaderCount?: number
  tableTitle?: string
}

const Table = ({
  data = [],
  columns,
  onClickRow,
  loading,
  filter,
  paginationProps,
  tableCS,
  hasBorderBottom,
  loaderCount,
  tableTitle,
}: TableProps) => {
  return (
    <>
      <StyleTableWrapper
        customStyle={{
          borderRadius: !!filter?.hasFilter ? 12 : 12,
          paddingTop: !!filter?.hasFilter ? 20 : 0,
        }}
      >
        {!!filter?.hasFilter && (
          <Filter filter={filter} tableTitle={tableTitle} />
        )}
        <div
          style={{
            overflowX: 'auto',
          }}
        >
          <StyleTable customStyle={{ ...tableCS }}>
            <TableHeader items={columns} />
            {!!loading ? (
              <TableLoader columns={columns} loaderCount={loaderCount} />
            ) : (
              <TableData
                items={data}
                columns={columns}
                onClickRow={onClickRow}
                hasBorderBottom={hasBorderBottom}
              />
            )}
          </StyleTable>
        </div>
      </StyleTableWrapper>
      {!!paginationProps && <Pagination {...paginationProps} />}
    </>
  )
}

export default Table
